import { render, staticRenderFns } from "./Assistance.vue?vue&type=template&id=c514c398&scoped=true&lang=html&"
import script from "./Assistance.vue?vue&type=script&lang=js&"
export * from "./Assistance.vue?vue&type=script&lang=js&"
import style0 from "./Assistance.vue?vue&type=style&index=0&id=c514c398&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c514c398",
  null
  
)

export default component.exports